import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { config } from '../../config/environment';
import { CognitoChallenge } from '../../services/cognitoAuthService';
import { landingPathForRole } from '../../utils/landingPath';
import LoginPage from './LoginPage';

const ScorecardLoginPage: React.FC = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  // Debug logging
  console.log('ScorecardLoginPage - Environment:', config.environment);
  console.log('ScorecardLoginPage - useDummyData:', config.useDummyData);
  console.log('ScorecardLoginPage - REACT_APP_ENVIRONMENT:', process.env.REACT_APP_ENVIRONMENT);

  // If user is already logged in, redirect to their role's landing page — the
  // pilot dashboard for staff (feat-083, unchanged), the interaction-evaluations
  // page for an evaluator (feat-191 C2, redirect site 1 of 4).
  // StaffRoute on the staff target gates by role: authed-non-staff sees "Access
  // denied" (no bounce, since :20 only fires when already authenticated), so no
  // redirect loop. Same for EvaluatorRoute on the evaluator target.
  if (user && user.isAuthenticated) {
    return <Navigate to={landingPathForRole(user.managementUser?.role)} replace />;
  }

  const handlePasswordChangeRequired = (email: string, challenge: CognitoChallenge) => {
    navigate('/change-password', {
      state: {
        email,
        session: challenge.session
      }
    });
  };

  return (
    <div>
      {/* Environment indicator for debugging */}
      {process.env.NODE_ENV === 'development' && (
        <div className="fixed top-4 right-4 bg-blue-100 text-blue-800 px-3 py-1 rounded text-sm">
          Environment: {config.environment} | Auth: {config.useDummyData ? 'Dummy' : 'Cognito'}
        </div>
      )}
      <LoginPage onLogin={login} onPasswordChangeRequired={handlePasswordChangeRequired} />
    </div>
  );
};

export default ScorecardLoginPage;
